module.exports = __webpack_public_path__ + "static/img/wariant4.485fa7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wariant4.png
// module id = aG/8
// module chunks = 1